export function getTranslatedTitleNotifications(
  title: string,
  t: (key: string) => string
): string {
  if (!title) return "";

  if (title.includes("New User registered")) {
    return t("newUserRegistered");
  } else if (title.includes("Draft Triage Report processing was Finished")) {
    return t("draftTriageReportProcessingFinished");
  } else if (title.includes("New Message Inbox")) {
    return t("newMessageInbox");
  } else if (title.includes("Closure Complaint Request - Approved")) {
    return t("closureComplaintRequestApproved");
  } else if (title.includes("Closure Complaint Request - Rejected")) {
    return t("closureComplaintRequestRejected");
  } else if (title.includes("New Closure Complaint Request")) {
    return t("newClosureComplaintRequest");
  } else if (title.includes("New Complaint Invalid")) {
    return t("newComplaintInvalid");
  } else if (title.includes("New Complaint")) {
    return t("notificationNewComplaint");
  } else if (title.includes("Complaint to Expiration")) {
    return t("complaintToExpiration");
  }

  return title; // fallback pro original
}
